"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Validates if input is an Array.
 *
 * @export
 * @class IsArrayValidator
 * @implements {PropertyValidator<any>}
 */
class IsArrayValidator {
    isValid(input) {
        return input instanceof Array;
    }
}
exports.IsArrayValidator = IsArrayValidator;
//# sourceMappingURL=IsArrayValidator.js.map